/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CompanyDto as DigiworkMaitreDDtoAdvertiserCompanyDto } from '../../models/Digiwork/MaitreD/DTO/Advertiser/company-dto';

export interface UpdateCompany$Params {
      body?: DigiworkMaitreDDtoAdvertiserCompanyDto
}

export function updateCompany(http: HttpClient, rootUrl: string, params?: UpdateCompany$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, updateCompany.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

updateCompany.PATH = '/api/gmn/Company/updatecompany';
